import * as Actions from "../../actions/app"

const initialState = {
  loading_purchases: false,
  purchases: [],
  total_purchases: 0,

  downloading_purchases_report: false,

  loading_purchase: false,
  purchase: null,

  loading_correction_summary: false,
  correction_summary: null,
  // Items de la compra. Llegan en la misma llamada que el resumen de cabecera.
  correction_items: [],
  // Credito del proveedor: null si la compra es al contado. Tambien viene en la
  // misma llamada que el resumen.
  correction_credit: null,
  loading_correction_items: false,
  // Campo de cabecera que se esta guardando en este momento y el motivo del
  // ultimo rechazo, para dibujarlos junto al campo y no en un modal aparte.
  loading_correction_field: false,
  saving_field: null,
  correction_field_error: null,

  // Estado del listado de compras realizadas. Vive en el store para que al navegar
  // a una correccion y volver, el operador caiga en la misma pagina y con los mismos
  // filtros, no arranquando de nuevo desde el primer registro.
  record_filters: {
    startDate: '',
    endDate: '',
    paymentType: '',
    search: '',
  },
  record_page: 1,

  loading_crud_purchase_header: false,
  crud_purchase_header: false,
  data_crud_purchase_header: null,

  loading_crud_purchase: false,
  crud_purchase: false,
  data_crud_purchase: null,

  loading_crud_purchase_item: false,
  crud_purchase_item: false,

  loading_purchase_items: false,
  purchase_items: null,

  loading_crud_item_correction: false,

  loading_finish_purchase_detail: false,
  finish_purchase_detail: false,

}

const purchasesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_PURCHASES: {
      return {
        ...state,
        loading_purchases: action.payload.loading ?? state.loading_purchases,
        purchases: action.payload.items ?? state.purchases,
        total_purchases: action.payload.total ?? state.total_purchases,
      }
    }

    case Actions.DOWNLOADING_PURCHASES_REPORT: {
      return {
        ...state,
        downloading_purchases_report: action.payload
      }
    }

    case Actions.GET_PURCHASE: {
      return {
        ...state,
        loading_purchase: action.payload.loading,
        purchase: action.payload.data,
      }
    }

    case Actions.GET_PURCHASE_CORRECTION_SUMMARY: {
      // Salir de la pagina de correccion limpia tambien el estado de edicion en
      // linea: si no, el proximo editor que se abre heredaria el error del campo
      // que se corrigio antes.
      return {
        ...state,
        loading_correction_summary: action.payload.loading ?? state.loading_correction_summary,
        correction_summary: action.payload.data !== undefined ? action.payload.data : state.correction_summary,
        correction_items: action.payload.items !== undefined ? action.payload.items : state.correction_items,
        // El credito del proveedor viene en `credito` y es null si la compra no es
        // a credito. Va aparte de la cabecera porque no existe en todas las
        // compras y porque se vuelve a pedir solo con el resumen.
        correction_credit: 'credito' in action.payload ? action.payload.credito : state.correction_credit,
        loading_correction_field: action.payload.data !== undefined ? false : state.loading_correction_field,
        saving_field: action.payload.data !== undefined ? null : state.saving_field,
        correction_field_error: action.payload.data !== undefined ? null : state.correction_field_error,
      }
    }

    case Actions.GET_PURCHASE_CORRECTION_ITEMS: {
      return {
        ...state,
        loading_correction_items: action.payload.loading ?? state.loading_correction_items,
        correction_items: action.payload.items !== undefined ? action.payload.items : state.correction_items,
      }
    }

    case Actions.SET_PURCHASE_RECORD_FILTERS: {
      return { ...state, record_filters: action.payload }
    }

    case Actions.SET_PURCHASE_RECORD_PAGE: {
      return { ...state, record_page: action.payload }
    }

    case Actions.CRUD_PURCHASE_HEADER: {
      return {
        ...state,
        loading_crud_purchase_header: action.payload.loading,
        crud_purchase_header: action.payload.crud,
        data_crud_purchase_header: action.payload.data,
      }
    }

    case Actions.CRUD_PURCHASE: {
      return {
        ...state,
        loading_crud_purchase: action.payload.loading,
        crud_purchase: action.payload.crud,
      }
    }

    case Actions.CRUD_PURCHASE_ITEM: {
      return {
        ...state,
        loading_crud_purchase_item: action.payload.loading,
        crud_purchase_item: action.payload.crud
      }
    }

    case Actions.CRUD_PURCHASE_ITEM_CORRECTION: {
      return {
        ...state,
        loading_crud_item_correction: action.payload.loading ?? state.loading_crud_item_correction,
        // El rechazo del backend se guarda para mostrarlo en la pagina: un toast
        // solo se pierde si el usuario no esta mirando en ese momento.
        correction_error: action.payload.error ?? (action.payload.loading ? null : state.correction_error),
      }
    }

    case Actions.CRUD_PURCHASE_PROVIDER: {
      return {
        ...state,
        loading_crud_provider: action.payload.loading ?? state.loading_crud_provider,
        correction_error: action.payload.error ?? (action.payload.loading ? null : state.correction_error),
      }
    }

    case Actions.CRUD_PURCHASE_CREDIT_NOTE: {
      return {
        ...state,
        loading_credit_note: action.payload.loading ?? state.loading_credit_note,
        correction_error: action.payload.error ?? (action.payload.loading ? null : state.correction_error),
      }
    }

    // Correccion de un campo suelto de la cabecera. El campo que se esta
    // guardando se guarda aparte para que cada fila sepa si debe mostrar su
    // propio spinner en vez de que se bloqueen todas.
    case Actions.CRUD_PURCHASE_FIELD: {
      return {
        ...state,
        loading_correction_field: action.payload.loading ?? state.loading_correction_field,
        /*
         * `saving_field` dice QUE se esta guardando, para que cada modal muestre su
         * spinner. Se limpia cuando ya no hay nada guardando: antes se llenaba
         * tambien en el dispatch de exito y se quedaba con el id para siempre, asi
         * que al volver a abrir ese modal el boton salia en loading y deshabilitado
         * sin poder volver a guardar. Tenia que recargar la pagina.
         */
        saving_field: action.payload.loading ? action.payload.campo ?? null : null,
        correction_error: action.payload.error ?? (action.payload.loading ? null : state.correction_error),
        correction_field_error: action.payload.error ?? (action.payload.loading ? null : state.correction_field_error),
      }
    }

    // Correccion de UNA linea de item. El detalle que se esta guardando se
    // guarda aparte, igual que el campo de la cabecera, para que el modal
    // muestre su propio spinner y su propio error.
    case Actions.CRUD_PURCHASE_ITEM_FIELD: {
      return {
        ...state,
        loading_correction_item: action.payload.loading ?? state.loading_correction_item,
        // Mismo criterio que `saving_field`: se limpia al terminar, no se queda con
        // el id del item guardado.
        saving_item: action.payload.loading ? action.payload.detalle_id ?? null : null,
        correction_item_error: action.payload.error ?? (action.payload.loading ? null : state.correction_item_error),
      }
    }

    case Actions.GET_PURCHASE_ITEMS: {
      return {
        ...state,
        loading_purchase_items: action.payload.loading,
        purchase_items: action.payload.data
      }
    }

    case Actions.FINISH_PURCHASE_DETAIL: {
      return {
        ...state,
        loading_finish_purchase_detail: action.payload.loading,
        finish_purchase_detail: action.payload.crud,
      }
    }

    default: {
      return state
    }
  }
}
export default purchasesReducer
